import { enumify } from '../utils/enumify'

export const CONNECTION_ENTRY_SOURCES = enumify(['primary', 'foreign'])
